module.exports = __webpack_public_path__ + "img/audio-feedback_en.9a98fb8.jpg";